import { Message } from '../services/chatService';

export const EDIT_WINDOW_MS = 15 * 60 * 1000;
export const DELETE_WINDOW_MS = 5 * 60 * 1000;
export const DELETED_MESSAGE_PLACEHOLDER = 'Message deleted';

const isSameUserId = (left?: string, right?: string) => left?.toString() === right?.toString();

const isWithinWindow = (createdAt: string | undefined, windowMs: number) => {
  if (!createdAt) return false;
  return Date.now() - new Date(createdAt).getTime() <= windowMs;
};

export const isMessageDeleted = (message: Pick<Message, 'deletedAt'>) => !!message.deletedAt;

export const canEditMessage = (message: Message, userId?: string) => {
  if (!message || !userId || isMessageDeleted(message)) return false;
  if (!isSameUserId(message.sender, userId)) return false;
  if ((message.attachments?.length ?? 0) > 0) return false;
  if (message._localStatus) return false;
  return isWithinWindow(message.createdAt, EDIT_WINDOW_MS);
};

export const canDeleteMessage = (message: Message, userId?: string) => {
  if (!message || !userId || isMessageDeleted(message)) return false;
  if (!isSameUserId(message.sender, userId)) return false;
  if (message._localStatus) return false;
  return isWithinWindow(message.createdAt, DELETE_WINDOW_MS);
};

export const getMessageDisplayContent = (message: Message) => {
  if (isMessageDeleted(message)) {
    return DELETED_MESSAGE_PLACEHOLDER;
  }
  return message.content;
};

export const canCopyMessage = (message: Message) =>
  !isMessageDeleted(message) && !!message.content?.trim();
